import {post,fetch as get,patch,put} from './interface';

const test = data =>{
    return get('https://weixin.518xqw.com/Api/Jiekou/cs_list', data);
}

//公共部分 底部和右侧部分
const pubdata = data =>{
    return get('/pubdata/index', data);
}
//导航分类
const column = data =>{
    return post('/column/index', data);
}

//首页整合
const indexAll = data =>{
    return post('/Indedata/index_all', data);
}
//课程分类
const category = data =>{
    return post('/category/index', data);
}

//培训对象
const training = data =>{
    return post('/training/index', data);
}


//首页 头条-轮播
const index = data =>{
    return post('/indedata/index', data);
}

//首页 广告
const indexAd = data =>{
    return post('/banner/index', data);
}

//文章列表
const article = data =>{
    return post('/article/index', data);
}

//文章详情
const articleInfo = data =>{
    return post('/article/info', data);
}

//课程中心
const course = data =>{
    return post('/course/index', data);
}

//课程详情
const courseInfo = data =>{
    return post('/course/info', data);
}
//注册
const reg = data =>{
    return post('/login/reg', data);
}
//登录
const login = data =>{
    return post('/login/login', data);
}
//忘记密码
const forget = data =>{
    return post('/login/forget', data);
}
//获取图形验证码
const getcode = data =>{
    return post('/login/getcode', data);
}

//获取用户数据
const userInfo = data =>{
    return post('/wuser/user_info', data);
}
//修改密码
const savePassword = data =>{
    return post('/wuser/save_password', data);
}
//账户总览
const userHome = data =>{
    return post('/wuser/index', data);
}
//消息
const userLog = data =>{
    return post('/wuser/indexlog', data);
}
//标志已读
const userSetLog = data =>{
    return post('/wuser/set_log', data);
}
//删除消息
const userDelLog = data =>{
    return post('/wuser/del_log', data);
}
//报名课程
const pay = data =>{
    return post('/pay/index', data);
}
//提交支付
const payIng = data =>{
    return post('/pay/pay_ing', data);
}
//支付结果
const payInfo = data =>{
    return post('/pay/pay_info', data);
}
//订单管理
const order = data =>{
    return post('/order/index', data);
}
//取消报名
const orderCancel = data =>{
    return post('/order/qx_enrolllist', data);
}

//修改用户数据
const userSaveData = data =>{
    return post('/wuser/save_data', data);
}

//证书记录
const certificate = data =>{
    return post('/wuser/certificate', data);
}

//开票信息
const invoice = data =>{
    return post('/wuser/invoice', data);
}

//开票编辑新增
const invoiceAdd = data =>{
    return post('/wuser/invoice_add', data);
}
//开票信息-删除
const delInvoice = data =>{
    return post('/wuser/del_invoice', data);
}

//发票详情
const findInvoice = data =>{
    return post('/wuser/find_invoice', data);
}

//求职招聘
const recruit = data =>{
    return post('/wuser/recruit', data);
}

//求职招聘新增-编辑
const recruitAdd = data =>{
    return post('/wuser/recruit_add', data);
}

//求职招聘详情
const recruitInfo = data =>{
    return post('/wuser/recruit_info', data);
}


//上传文件
const up_word = data =>{
    return post('/Pubdata/uploadimg', data);
}

//求职招聘删除
const delRecruit = data =>{
    return post('/wuser/del_recruit', data);
}


//订单详情
const orderInfo = data =>{
    return post('/order/order_info', data);
}

//网授线上课程
const trainlist = data =>{
    return post('/trainlist/index', data);
}

//查看复习题
const subject = data =>{
    return post('/trainlist/subject', data);
}

//延长学习时间
const orderStudy = data =>{
    return post('/trainlist/order_study', data);
}


//复习题进入学习
const study = data =>{
    return post('/trainlist/study', data);
}

//复习题判断
const studyRight = data =>{
    return post('/trainlist/study_r', data);
}

//视频学习
const study2 = data =>{
    return post('/trainlist/study2', data);
}

//视频看完记录
const complete = data =>{
    return post('/trainlist/complete', data);
}

//考试
const zxExam = data =>{
    return post('/trainlist/zx_exam', data);
}
//考试答案
const zxexamAnswer = data =>{
    return post('/trainlist/zxexam_answer', data);
}
//提交在线考试
const zxexamRes = data =>{
    return post('/trainlist/zxexam_res', data);
}
//发票管理
const invoicing = data =>{
    return post('/wuser/invoicing', data);
}
//发票管理详情
const findInvoicing = data =>{
    return post('/wuser/find_invoicing', data);
}
// 企业管理
// 员工管理
const qiyeUser = data =>{
    return post('/wuser/qiye_user', data);
}
// 修改员工密码
const savePaw = data =>{
    return post('/wuser/save_paw', data);
}
// 	企业选择报名
const qyEnroll = data =>{
    return post('/pay/qy_enroll', data);
}

// 企业报名成功
const enrollSuc = data =>{
    return post('/pay/enroll_res', data);
}

// 企业订单支付
const qyPayIng = data =>{
    return post('/pay/qy_pay_ing', data);
}

// 企业培训记录
const cTraining = data =>{
    return post('/company/training', data);
}
//课程管理
const cCourse = data =>{
    return post('/company/course', data);
}
// 培训记录-查看员工
const lookUser = data =>{
    return post('/company/look_user', data);
}
// 补考管理
const cMakeUp = data =>{
    return post('/company/make_up', data);
}
// 补考管理-补考员工
const cBkUser = data =>{
    return post('/company/bk_user', data);
}
// 补考管理-未交费 已缴费
const cBkPay = data =>{
    return post('/company/bk_pay', data);
}
//补考管理-分班员工
const cBkClasses = data =>{
    return post('/company/bk_classes', data);
}

//课程管理-报名-缴费
const bmUser = data =>{
    return post('/company/bm_user', data);
}

//课程管理-批量取消报名
const qyMoreQxbm = data =>{
    return post('/pay/qy_more_qxbm', data);
}
//课程管理-企业批量支付
const qyShowMoreUser = data =>{
    return post('/pay/qy_show_more_user', data);
}

//查询证书
const findZscode = data =>{
    return post('/Article/find_zscode', data);
}

//查询成功
const paySucc = data =>{
    return post('/Pay/pay_succ', data);
}

//招聘
const recruitList = data =>{
    return post('/recruit/index', data);
}

//招聘详情
const wrecruitInfo = data =>{
    return post('/recruit/info', data);
}

//注册验证
const findRepeat = data =>{
    return post('/login/find_repeat', data);
}

//登录通知
const notice = data =>{
    return post('/wuser/notice', data);
}
// 企业报名验证
const checkOrder = data =>{
    return post('/Pay/check_order', data);
}

// 查看考试记录
const examLog = data =>{
    return post('/trainlist/exam_log', data);
}

// 发送短信 找回密码
const sendMobile = data =>{
    return post('/sendmobile/index', data);
}

// 发送短信 注册账号
const sendRegMobile = data =>{
    return post('/sendmobile/send_reg_mobile', data);
}

// 企业发票记录
const companyCertificate = data =>{
    return post('/company/certificate', data);
}


// 学员注册判断
const login_code = data =>{
    return post('/login/find_re_mobile', data);
}

// 	邮寄服务
const mail = data =>{
    return post('/Mail/index', data);
}

//获取未邮寄订单
const mailGetOrder = data =>{
    return post('/Mail/get_order', data);
}

//提交邮寄服务
const mailInsert = data =>{
    return post('/Mail/insert', data);
}

//提交邮寄服务
const region = data =>{
    return get('/Mail/ajax_region', data);
}

//视频更多
const getMoreVideo = data =>{
    return get('/Trainlist/get_more_video', data);
}

//保存题目记录 order_id    data
const saveOrderAnswer = data =>{
    return post('/trainlist/save_order_answer', data);
}

//获取题目记录 order_id    data
const getOrderAnswer = data =>{
    return post('/trainlist/get_order_answer', data);
}


//记录次数
// wuser_id
// order_id
const saveOrderAnswerEnd = data =>{
    return post('/trainlist/save_order_answer_end', data);
}

const testexamList = data =>{
    return get('/Indedata/testexam_list', data);
}

const findUser = data =>{
    return post('/course/find_user', data);
}

// 证书列表
const certificates = data =>{
    return post('/certificates/index', data);
}

// 添加修改证书
const certificatesAdd = data =>{
    return post('/certificates/add_ing', data);
}

// 添加修改证书
const certificatesInfo = data =>{
    return post('/certificates/add', data);
}

// 删除证书
const certificatesDel = data =>{
    return post('/certificates/del', data);
}

// 证书-企业导出模板
const certificatesDaochus = data =>{
    return get('/certificates/daochus', data);
}

const certificatesDaorus = data =>{
    return post('/certificates/daorus', data);
}

const training2 = data =>{
    return post('/training/index2', data);
}

const hotIndex = data =>{
    return post('/course/hot_index', data);
}

const aiIndex = data =>{
    return post('/course/ai_index', data);
}

const courseCompose = data =>{
    return get('/course/course_compose', data);
}

const courseComposeInfo = data =>{
    return get('/course/course_compose_info', data);
}

const courseComposeList = data =>{
    return get('/course/course_compose_list', data);
}

const courseIndex = data =>{
    return get('/certificates/course_index', data);
}

const saveMobile = data =>{
    return post('/certificates/save_mobile', data);
}
const major = data =>{
    return get('/pubdata/major', data);
}

const certsign = data =>{
    return post('/certificates/certsign', data);
}
const certmajor = data =>{
    return post('/certificates/certmajor', data);
}

const noticeNew = data =>{
    return post('/wuser/notice_new', data);
}
/*
传  
order  订单编号
admin_code   老师编号。 
*/
const setAdminCode = data =>{
    return post('/order/set_admin_code', data);
}
const courseComposeAll = data =>{
    return get('/course/course_compose_all', data);
}


const artindex2 = data =>{
    return post('/Article/index', data)
}



const userCourse = data =>{
    return post('/user/course', data)
}


const courseShowlist = data =>{
    return get('/course/showlist', data)
}


//购物车列表
const cartIndex = data =>{
    return get('/cart/index', data)
}

//添加购物车
const cartAdd = data =>{
    return post('/cart/add', data)
}

//删除
const cartDel = data =>{
    return post('/cart/del', data)
}

//购物车提交报名
const addOrder = data =>{
    return post('/cart/add_order', data)
}

//显示购物车订单数据
const showCartOrder = data =>{
    return post('/cart/show_cart_order', data)
}

//购物车订单支付
const cartPayIng = data =>{
    return post('/pay/cart_pay_ing', data)
}

//下载文档
const downWord = data =>{
    return get('/wuser/down_word', data)
}

//导出
export default {
	downWord,
	cartIndex,
	cartAdd,
	cartDel,
	addOrder,
	showCartOrder,
	cartPayIng,
	courseShowlist,
	userCourse,
	artindex2,
	courseComposeAll,
	setAdminCode,
	noticeNew,
	certsign,
	certmajor,
	major,
	saveMobile,
	courseIndex,
	hotIndex,
	aiIndex,
	courseCompose,
	courseComposeInfo,
	courseComposeList,
	training2,
	findUser,
	saveOrderAnswerEnd,
	testexamList,
    login_code,
    pubdata,
    column,
    indexAll,
    index,
    indexAd,
    article,
    articleInfo,
    course,
    courseInfo,
    category,
    training,
    reg,
    login,
    forget,
    getcode,
    userInfo,
    userHome,
    userLog,
    userSetLog,
    userDelLog,
    pay,
    userSaveData,
    certificate,
    invoice,
    invoiceAdd,
    findInvoice,
    payIng,
    payInfo,
    order,
    orderCancel,
    recruit,
    recruitAdd,
    savePassword,
    recruitInfo,
    delRecruit,
    orderInfo,
    trainlist,
    subject,
    study,
    study2,
    complete,
    studyRight,
    orderStudy,
    zxExam,
    zxexamAnswer,
    zxexamRes,
    invoicing,
    findInvoicing,
    delInvoice,
    
    qiyeUser,
    savePaw,
    qyEnroll,
    enrollSuc,
    qyPayIng,
    cTraining,
    lookUser,
    cMakeUp,
    cBkUser,
    cCourse,
    cBkPay,
    cBkClasses,
    bmUser,
    qyMoreQxbm,
    qyShowMoreUser,
    findZscode,
    paySucc,
    recruitList,
    wrecruitInfo,
    findRepeat,
    notice,
    checkOrder,
	examLog,
	sendMobile,
	sendRegMobile,
	companyCertificate,
    up_word,
	mail,
	mailGetOrder,
	mailInsert,
	region,
	getMoreVideo,
	saveOrderAnswer,
	getOrderAnswer,
	certificates,
	certificatesAdd,
	certificatesInfo,
	certificatesDel,
	certificatesDaochus,
}
